module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781607051671_06_pre#pre"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("PREFACE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781607051671_07_int#int"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_09_bas#bas",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("THE BASICS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#pt01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("Part 1: THE FLOWERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Baltimore Beauty Flower")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Bluebells")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Chrysanthemum")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Dahlia")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Daisy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Forget-Me-Not")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Fuchsia (Single and Double)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Grapes / Wisteria / Hanging Blooms")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Iris")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Lily")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Michaelmas Daisy / Coneflower")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Mimosa / Floral Spray / Berries")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Pansy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Peony")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Pomegranate")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Star Flower")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Stargazer Lily")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Sunflower / Aster / Zinnia")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Sweet William")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Whirled Flower")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Easy Template Flowers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Butterfly")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Nosegay")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_10_pt01#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Additional Leaf Templates")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("Part 2: THE PROJECTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17½″ × 17½″ Pillows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev26",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Butterfly and Berries")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev27",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Autumn Tiger Lily with Asters")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev28",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Forget-Me-Nots and Pansies")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev29",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_vm._v("Baltimore Beauty and Bluebells")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev30",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Spring Wreath")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev31",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Harvest Wreath")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev32",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Jacobean Tree of Life")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev33",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Star Flower Heart")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev34",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Mexican Heart")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev35",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Vine Fruits")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Table Runner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev36",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Floral Sampler")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev37",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Indian Garden")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev38",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Jacobean Sampler")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_11_pt02#lev39",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_6F6697"
  }, [_c('em', [_vm._v("Floral Fantasy")])])]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Wallhanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_12_pt03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("Part 3: THE BORDERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_12_pt03#lev40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple 1″ Sawtooth Border")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_12_pt03#lev41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Sawtooth with Circles Border")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_12_pt03#lev42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Daisy and Hearts Border")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_12_pt03#lev43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuchsia Border and Corner Design")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_12_pt03#lev44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chrysanthemum Border")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_13_gal#gal",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("GALLERY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781607051671_14_aut#aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "bg_A1A34C"
  }, [_vm._v("ABOUT THE AUTHOR")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5539663a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781607051671_05_toc.vue
// module id = 72
// module chunks = 0